<template>
	<div id="schrittanzeige">

		<div class="row mb-5">
			<div class="col-12 col-lg-8 offset-lg-2">
				<div class="form-step-container">

					<div :class="{ 'form-step-box' : schritt !== 1, 'form-step-box form-box-active' : schritt === 1 }">1</div>
					<div :class="{ 'form-step-line' : schritt !== 1, 'form-step-line form-box-active' : schritt === 1 }"></div>

					<div :class="{ 'form-step-box' : schritt !== 2, 'form-step-box form-box-active' : schritt === 2 }">2</div>
					<div :class="{ 'form-step-line' : schritt !== 2, 'form-step-line form-box-active' : schritt === 2 }"></div>

					<div :class="{ 'form-step-box' : schritt !== 3, 'form-step-box form-box-end' : schritt === 3 }"><i class="fa fa-check" aria-hidden="true"></i></div>

				</div>
			</div>
		</div>

		<div class="row">
			<div class="col-12 col-lg-8 offset-lg-2">
				<p v-if="erhoehung" class="form-info-text">
          Lassen Sie von uns <b>kostenlos</b> prüfen, ob Sie eine Rückerstattung der Beitragskosten bei Ihrer Privaten Krankenversicherung erreichen können!
        </p>
        <p v-else-if="datenvervollstaendigung" class="form-info-text">
          Auf dieser Seite können Sie schnell und einfach Ihre Unterlagen hochladen und Ihre Angaben vervollständigen.
        </p>
        <p v-else class="form-info-text">
          Lassen Sie sich <b>kostenlos</b> zu günstigeren Alternativen zu ihrer privaten Krankenversicherung beraten.
        </p>
			</div>
		</div>

	</div>
</template>
<script>
export default {

	name: "Schrittanzeige",
	props: ['schritt','erhoehung','datenvervollstaendigung']

}
</script>
